import ApiClient from '../ApiClient';

const appId = process.env.REACT_APP_DEFAULT_APP_ID; //pass the app ID based on login

const AutomationService = {
  async fetchWebinarFollowUpSettings() {
    if (!appId) throw new Error('appId is required');
    const resp = await ApiClient.get(`/Automations/get-all-follow-up-settings`);
    return resp;
  },

  async updateFollowUpSettings(payload) {
    if (!appId) throw new Error("appId is required");

    const endpoint = "/Automations/update-follow-up-settings";

    return ApiClient.patch(
      endpoint,
      payload,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
  },

  async fetchAllEmailFollowUpTemplates() {
    if (!appId) throw new Error('appId is required');
    const resp = await ApiClient.get(`/Automations/get-all-email-follow-up-templates`);
    return resp;
  },  

  async fetchAllDefaultEmailFollowUpTemplates() {
    if (!appId) throw new Error('appId is required');
    const resp = await ApiClient.get(`/Automations/get-all-default-email-follow-up-templates`);
    return resp;
  },

  async CreateEmailFollowUpTemplate(payload) {
    if (!appId) throw new Error("appId is required");

    const endpoint = "/Automations/add-email-follow-up-template";

    return ApiClient.post(endpoint, payload, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
},

async UpdateEmailFollowUpTemplate(payload) {
    if (!appId) throw new Error("appId is required");

    const endpoint = "/Automations/update-email-follow-up-template";

    return ApiClient.patch(endpoint, payload, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
},

  async fetchLeadFollowUpSettings() {
    if (!appId) throw new Error('appId is required');
    const resp = await ApiClient.get(`/Automations/get-lead-follow-up-settings`);
    return resp;
  },  

  async AddUpdateLeadFollowUpSetting(payload) {
    if (!appId) throw new Error("appId is required");

    const endpoint = "/Automations/add-lead-follow-up-setting";

    return ApiClient.post(
      endpoint,
      payload,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
  },

  async UploadEmailTemplateImage(formData) {
    if (!appId) throw new Error("appId is required");

    return ApiClient.post(
        "/Automations/upload-email-template-image",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );
},
};

export default AutomationService;
